/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Misc_Fairuse_Section6title2Inputs */

const id_misc_fairuse_section6title2 = /** @type {(inputs: Misc_Fairuse_Section6title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6. Hubungi Kami`)
};

const ms_misc_fairuse_section6title2 = /** @type {(inputs: Misc_Fairuse_Section6title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6. Hubungi Kami`)
};

const da_misc_fairuse_section6title2 = /** @type {(inputs: Misc_Fairuse_Section6title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6. Kontakt Os`)
};

const de_misc_fairuse_section6title2 = /** @type {(inputs: Misc_Fairuse_Section6title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6. Kontaktieren Sie uns`)
};

const en_us2_misc_fairuse_section6title2 = /** @type {(inputs: Misc_Fairuse_Section6title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6. Contact Us`)
};

const es_es2_misc_fairuse_section6title2 = /** @type {(inputs: Misc_Fairuse_Section6title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6. Contáctanos`)
};

const es_mx2_misc_fairuse_section6title2 = /** @type {(inputs: Misc_Fairuse_Section6title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6. Contáctanos`)
};

const fil_misc_fairuse_section6title2 = /** @type {(inputs: Misc_Fairuse_Section6title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6. Makipag-ugnayan sa Amin`)
};

const fr_misc_fairuse_section6title2 = /** @type {(inputs: Misc_Fairuse_Section6title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6. Nous contacter`)
};

const it_misc_fairuse_section6title2 = /** @type {(inputs: Misc_Fairuse_Section6title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6. Contattaci`)
};

const hu_misc_fairuse_section6title2 = /** @type {(inputs: Misc_Fairuse_Section6title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6. Kapcsolat`)
};

const nl_misc_fairuse_section6title2 = /** @type {(inputs: Misc_Fairuse_Section6title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6. Neem contact op`)
};

const no_misc_fairuse_section6title2 = /** @type {(inputs: Misc_Fairuse_Section6title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6. Kontakt oss`)
};

const pl_misc_fairuse_section6title2 = /** @type {(inputs: Misc_Fairuse_Section6title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6. Kontakt`)
};

const pt_br2_misc_fairuse_section6title2 = /** @type {(inputs: Misc_Fairuse_Section6title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6. Contate-nos`)
};

const pt_misc_fairuse_section6title2 = /** @type {(inputs: Misc_Fairuse_Section6title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6. Contacte-nos`)
};

const ro_misc_fairuse_section6title2 = /** @type {(inputs: Misc_Fairuse_Section6title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6. Contactați-ne`)
};

const fi_misc_fairuse_section6title2 = /** @type {(inputs: Misc_Fairuse_Section6title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6. Ota yhteyttä`)
};

const sv_misc_fairuse_section6title2 = /** @type {(inputs: Misc_Fairuse_Section6title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6. Kontakta oss`)
};

const vi_misc_fairuse_section6title2 = /** @type {(inputs: Misc_Fairuse_Section6title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6. Liên hệ với chúng tôi`)
};

const tr_misc_fairuse_section6title2 = /** @type {(inputs: Misc_Fairuse_Section6title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6. Bizimle İletişime Geçin`)
};

const cs_misc_fairuse_section6title2 = /** @type {(inputs: Misc_Fairuse_Section6title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6. Kontaktujte nás`)
};

const bg_misc_fairuse_section6title2 = /** @type {(inputs: Misc_Fairuse_Section6title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6. Свържете се с нас`)
};

const ru_misc_fairuse_section6title2 = /** @type {(inputs: Misc_Fairuse_Section6title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6. Свяжитесь с нами`)
};

const uk_misc_fairuse_section6title2 = /** @type {(inputs: Misc_Fairuse_Section6title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6. Зв'яжіться з нами`)
};

const ar_misc_fairuse_section6title2 = /** @type {(inputs: Misc_Fairuse_Section6title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6. اتصل بنا`)
};

const hi_misc_fairuse_section6title2 = /** @type {(inputs: Misc_Fairuse_Section6title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6. संपर्क`)
};

const th_misc_fairuse_section6title2 = /** @type {(inputs: Misc_Fairuse_Section6title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6. ติดต่อเรา`)
};

const ja_misc_fairuse_section6title2 = /** @type {(inputs: Misc_Fairuse_Section6title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6. お問い合わせ`)
};

const zh_cn2_misc_fairuse_section6title2 = /** @type {(inputs: Misc_Fairuse_Section6title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6. 联系我们`)
};

const zh_hant1_misc_fairuse_section6title2 = /** @type {(inputs: Misc_Fairuse_Section6title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6. 聯絡我們`)
};

const ko_misc_fairuse_section6title2 = /** @type {(inputs: Misc_Fairuse_Section6title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6. 문의하기`)
};

/**
* | output |
* | --- |
* | "6. Contact Us" |
*
* @param {Misc_Fairuse_Section6title2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const misc_fairuse_section6title2 = /** @type {((inputs?: Misc_Fairuse_Section6title2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Misc_Fairuse_Section6title2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_misc_fairuse_section6title2(inputs)
	if (locale === "ms") return ms_misc_fairuse_section6title2(inputs)
	if (locale === "da") return da_misc_fairuse_section6title2(inputs)
	if (locale === "de") return de_misc_fairuse_section6title2(inputs)
	if (locale === "en-US") return en_us2_misc_fairuse_section6title2(inputs)
	if (locale === "es-ES") return es_es2_misc_fairuse_section6title2(inputs)
	if (locale === "es-MX") return es_mx2_misc_fairuse_section6title2(inputs)
	if (locale === "fil") return fil_misc_fairuse_section6title2(inputs)
	if (locale === "fr") return fr_misc_fairuse_section6title2(inputs)
	if (locale === "it") return it_misc_fairuse_section6title2(inputs)
	if (locale === "hu") return hu_misc_fairuse_section6title2(inputs)
	if (locale === "nl") return nl_misc_fairuse_section6title2(inputs)
	if (locale === "no") return no_misc_fairuse_section6title2(inputs)
	if (locale === "pl") return pl_misc_fairuse_section6title2(inputs)
	if (locale === "pt-BR") return pt_br2_misc_fairuse_section6title2(inputs)
	if (locale === "pt") return pt_misc_fairuse_section6title2(inputs)
	if (locale === "ro") return ro_misc_fairuse_section6title2(inputs)
	if (locale === "fi") return fi_misc_fairuse_section6title2(inputs)
	if (locale === "sv") return sv_misc_fairuse_section6title2(inputs)
	if (locale === "vi") return vi_misc_fairuse_section6title2(inputs)
	if (locale === "tr") return tr_misc_fairuse_section6title2(inputs)
	if (locale === "cs") return cs_misc_fairuse_section6title2(inputs)
	if (locale === "bg") return bg_misc_fairuse_section6title2(inputs)
	if (locale === "ru") return ru_misc_fairuse_section6title2(inputs)
	if (locale === "uk") return uk_misc_fairuse_section6title2(inputs)
	if (locale === "ar") return ar_misc_fairuse_section6title2(inputs)
	if (locale === "hi") return hi_misc_fairuse_section6title2(inputs)
	if (locale === "th") return th_misc_fairuse_section6title2(inputs)
	if (locale === "ja") return ja_misc_fairuse_section6title2(inputs)
	if (locale === "zh-CN") return zh_cn2_misc_fairuse_section6title2(inputs)
	if (locale === "zh-Hant") return zh_hant1_misc_fairuse_section6title2(inputs)
	return ko_misc_fairuse_section6title2(inputs)
});
export { misc_fairuse_section6title2 as "misc.fairUse.section6Title" }